import LegalLayout, { Section } from "@/components/site/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout
      eyebrow="Cookies"
      title="Cookie Policy"
      updated="December 2025"
      seo={{
        title: "Cookie Policy | Xadentra",
        description: "What cookies Xadentra uses, why we use them, and how you can manage your preferences.",
        path: "/cookie-policy",
      }}
    >
      <p className="text-base text-[#07111F]">
        This Cookie Policy explains what cookies are, how Xadentra uses them, and how you can manage
        your preferences. It should be read together with our{" "}
        <a href="/privacy-policy" className="text-[#6D4DFF] underline">Privacy Policy</a>.
      </p>

      <Section title="What are cookies?">
        <p>Cookies are small text files placed on your device when you visit a website. They are used to make websites work, improve user experience, measure performance, and personalize content and marketing.</p>
      </Section>

      <Section title="Why Xadentra uses cookies">
        <p>We use cookies to operate the website, remember your preferences, understand how visitors interact with our content, and (with your consent) measure marketing performance.</p>
      </Section>

      <Section title="Cookie categories">
        <ul className="list-disc pl-6 space-y-2">
          <li><strong className="text-[#07111F]">Strictly necessary.</strong> Required for the site to function (e.g. routing, security, consent state). Always on; cannot be disabled.</li>
          <li><strong className="text-[#07111F]">Analytics.</strong> Anonymous product analytics that help us understand which pages and content help visitors. Currently provided by PostHog. Loaded only after you accept analytics cookies.</li>
          <li><strong className="text-[#07111F]">Marketing.</strong> Not currently active on this site. Reserved for any future advertising or remarketing tags. If we add them, they will load only after you accept marketing cookies.</li>
          <li><strong className="text-[#07111F]">Functional.</strong> Remember in-page preferences and the AI chat conversation context. Loaded only after you accept functional cookies.</li>
        </ul>
      </Section>

      <Section title="Third-party tools we use">
        <p>
          We currently use <strong className="text-[#07111F]">PostHog</strong> for anonymous product
          analytics (only after analytics consent). We may use Google Tag Manager in the future as a
          governance layer; if we do, no tags inside it will fire before the matching consent category
          is granted.
        </p>
        <p className="mt-3">
          Form submissions and any business email you send us are processed through standard email
          and CRM tooling and are not considered cookies. See our{" "}
          <a href="/privacy-policy" className="text-[#6D4DFF] underline">Privacy Policy</a>.
        </p>
      </Section>

      <Section title="Managing consent">
        <p>
          You can <strong className="text-[#07111F]">Accept all</strong>,{" "}
          <strong className="text-[#07111F]">Reject all</strong>, or{" "}
          <strong className="text-[#07111F]">Manage preferences</strong> using our cookie banner.
          You can re-open the banner anytime via the <strong className="text-[#07111F]">Cookie
          Preferences</strong> link in the footer. Your browser may also let you delete or block
          cookies; doing so may impact site functionality.
        </p>
      </Section>

      <Section title="Contact">
        <p>Questions can be sent to <a href={"mail" + "to:" + "contact" + "@" + "xadentra.com"} className="text-[#6D4DFF] underline">{"contact" + "@" + "xadentra.com"}</a>.</p>
      </Section>
    </LegalLayout>
  );
}
